/** Collection layout previews reuse the existing facets and results-list contracts. */
function prepareLayout() {
  const root = document.querySelector('results-list[data-cll-view]');
  if (!root) return;
  const view = root.dataset.cllView;
  const themeId = root.dataset.cllTheme;
  if (!view) return;
  const grid = root.querySelector('.product-grid');
  if (grid) grid.setAttribute('product-grid-view', 'default');
  for (const form of root.querySelectorAll('form.facets__form, form[ref="facetsForm"]')) {
    let input = form.querySelector('input[name="view"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = 'view'; form.append(input);
    }
    input.value = view;
    if (themeId && view !== 'racket-detail') {
      let themeInput = form.querySelector('input[name="preview_theme_id"]');
      if (!themeInput) {
        themeInput = document.createElement('input');
        themeInput.type = 'hidden'; themeInput.name = 'preview_theme_id'; form.append(themeInput);
      }
      themeInput.value = themeId;
    }
  }
  const scopes = [root, ...document.querySelectorAll('.cfc-section:not([data-cfc-visual="none"]), collection-breadcrumb, header-component')];
  for (const scope of scopes) {
    if (view === 'racket-detail' && scope.matches('header-component')) continue;
    for (const link of scope.querySelectorAll('a[href]')) {
      const url = new URL(link.href, location.href);
      const parts = url.pathname.split('/').filter(Boolean);
      const at = parts.indexOf('collections');
      if (url.origin !== location.origin || at === -1 || parts.length !== at + 2) continue;
      url.searchParams.set('view', view);
      if (themeId && view !== 'racket-detail') url.searchParams.set('preview_theme_id', themeId);
      link.href = url.href;
    }
  }
}
document.addEventListener('click', (event) => {
  const target = event.target.closest?.('[data-cll-open-filters], [data-cll-filter-link]');
  if (!target) return;
  const root = target.closest('results-list[data-cll-view]');
  if (!root) return;
  if (target.matches('[data-cll-open-filters]')) {
    root.querySelector('.facets-toggle__button')?.click();
  } else if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
    const form = root.querySelector('facets-form-component');
    if (typeof form?.updateFiltersByURL === 'function') {
      event.preventDefault(); form.updateFiltersByURL(target.href);
    }
  }
});
document.addEventListener('dialog:close', (event) => {
  if (event.target.id !== 'filters-drawer') return;
  const button = event.target.closest?.('results-list[data-cll-view]')?.querySelector('[data-cll-open-filters]');
  if (button?.getClientRects().length) button.focus({ preventScroll: true });
}, true);
document.addEventListener('filter:update', prepareLayout);
document.addEventListener('collection:navigate', prepareLayout);
document.addEventListener('shopify:section:load', prepareLayout);
prepareLayout();
